import React, { useState,useEffect } from "react";
import icon from '../../Images/change-password-icon.png';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { changePassword } from "../../Redux/Auth/authActions";
import LoadingScreen from '../../ReusableBlocks/LoadingScreen';
import Swal from 'sweetalert2';
import Cookies from 'js-cookie';


const ChangePassword = () => {
    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [validation, setValidation] = useState({
        length: false,
        uppercase: false,
        number: false,
        specialChar: false,
    });

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const isLoading = useSelector((state) => state.auth.isLoading); // Get loading state from Redux


    const handlePasswordChange = (e) => {
        const value = e.target.value;
        setNewPassword(value);

        setValidation({
            length: value.length >= 8,
            uppercase: /[A-Z]/.test(value),
            number: /[0-9]/.test(value),
            specialChar: /[!@#$%^&*_-]/.test(value), // underscore added here
        });
    };

    const isButtonDisabled =
        !validation.length ||
        !validation.uppercase ||
        !validation.number ||
        !validation.specialChar ||
        newPassword !== confirmPassword;

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!validation.length) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Password must be at least 8 characters long",
                confirmButtonColor: "#052140"
            });
            return;
        }
        if (!validation.uppercase) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Password must contain at least one uppercase letter",
                confirmButtonColor: "#052140"
            });
            return;
        }
        if (!validation.number) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Password must contain at least one number",
                confirmButtonColor: "#052140"
            });
            return;
        }
        if (!validation.specialChar) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Password must contain at least one special character",
                confirmButtonColor: "#052140"
            });
            return;
        }
        if (newPassword !== confirmPassword) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "The new password and confirmation password do not match. Please try again",
                confirmButtonColor: "#052140"
            });
            return;
        }

        dispatch(changePassword(oldPassword, newPassword, confirmPassword, navigate));
    };


  


    return (
        <>
            {isLoading && <LoadingScreen />}
            <section className="chg-pass-section d-flex justify-content-center align-items-center vh-100">
                <div className="chg-pass-container bg-white shadow-lg rounded  d-flex flex-column flex-md-row">
                    {/* Left Section: Input Fields */}
                    <div className="chg-pass-left p-4 w-100">
                        <h3 className="chg-pass-title">Change your password</h3>
                        <p className="chg-pass-subtext">
                            You must change your password every <strong>30 days</strong>
                        </p>

                        <form onSubmit={handleSubmit}>
                            <div className="mb-3">
                                <label className="chg-pass-label" htmlFor="oldPassword">Old Password</label>
                                <input
                                    type="password"
                                    className="chg-pass-input"
                                    value={oldPassword}
                                    onChange={(e) => setOldPassword(e.target.value)}
                                    required
                                />
                            </div>

                            <div className="mb-3">
                                <label className="chg-pass-label" htmlFor="newPassword">New Password</label>
                                <input
                                    type="password"
                                    className="chg-pass-input"
                                    value={newPassword}
                                    onChange={handlePasswordChange}
                                    required
                                />
                            </div>

                            <div className="mb-3">
                                <label className="chg-pass-label" htmlFor="confirmPassword">Confirm New Password</label>
                                <input
                                    type="password"
                                    className="chg-pass-input"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    required
                                />
                            </div>

                            <button type="submit" className="btn chg-pass-btn w-100" disabled={isLoading}>Change Password</button>
                        </form>

                        {/* <p
                            className="chg-pass-back text-center mt-3"
                            style={{ cursor: 'pointer' }}
                            onClick={handleBackToLogin}
                        >
                            ← Back to Login
                        </p> */}

                    </div>

                    {/* Right Section: Password Validation */}
                    <div className="chg-pass-right p-5 w-100">
                        <div className="chg-pass-lock-icon">
                            <img
                                src={icon}
                                alt="Lock Icon"
                                className="chg-pass-lock-img"
                                style={{ width: "120px", height: "120px" }}
                            />
                        </div>

                        <h5 className="chg-pass-rules-title">Password Must:</h5>
                        <ul className="list-unstyled">
                            <li className={validation.length ? "valid" : ""}>
                                ✔ Contains at least 8 characters
                            </li>
                            <li className={validation.uppercase ? "valid" : ""}>
                                ✔ Contains at least One Uppercase (A-Z)
                            </li>
                            <li className={validation.number ? "valid" : ""}>
                                ✔ Contains at least One Number (0-9)
                            </li>
                            <li className={validation.specialChar ? "valid" : ""}>
                                ✔ Contains at least One Special Character ($#@%!_)
                            </li>
                        </ul>
                    </div>
                </div>
            </section>
        </>
    );
};

export default ChangePassword;
